const PublicHeader = ({ referenceNumber }) => {
    return (
        <header className="w-full h-16 bg-white shadow flex items-center justify-between px-6">
            {/* Empty space for left side */}
            <div className="w-1/3">{referenceNumber ? `Reference Number: ${referenceNumber}` : ""}</div>

            {/* Left: Logo */}
            <div
                className="w-1/3 flex justify-center"
            >
                <img
                    src="/logo.png"
                    alt="VerifiedID Logo"
                    className="w-40 h-auto hover:opacity-80 transition-opacity duration-200"
                />
            </div>

            {/* Empty space for left side */}
            <div className="w-1/3"></div>
        </header>
    )
}

export default PublicHeader
